@let job = batchJob();
<h3>Status</h3>
<table class="detail-table bordered">
  <tr>
    <td class="detail-label">Jobtype</td>
    <td>
      {{ job.batchJobSchedule.batchJobType.navn }}
    </td>
  </tr>
  <tr>
    <td class="detail-label">Oprettet af</td>
    <td>{{ job.oprettetAfNavn }} ({{ job.oprettetAfBrugerId }})</td>
  </tr>
  <tr>
    <td class="detail-label">Startet</td>
    <td>{{ job.start | date: 'dd-MM-yyyy HH:mm:ss' }}</td>
  </tr>
  <tr>
    <td class="detail-label">Status</td>
    <td>{{ job.status }}</td>
  </tr>
  <tr>
    <td class="detail-label">Afsluttet</td>
    <td>{{ job.slut | date: 'dd-MM-yyyy HH:mm:ss' }}</td>
  </tr>
</table>

@if (allowEdit()) {
  <p-button label="Genstart" (click)="genstartJob(job)" />
}

<h3>Job parametre</h3>
<table class="detail-table bordered">
  @if (parameters.isLoading()) {
    <p-skeleton width="10rem" class="mb-2" />
    <p-skeleton width="5rem" class="mb-2" />
    <p-skeleton width="15rem" class="mb-2" />
  }
  @let params = parameters.value()?.data;
  @if (params) {
    @for (p of params; track p.id) {
      <tr>
        <td class="detail-label">{{ p.parameterNavn }}</td>
        <td>{{ p.parameterVaerdi }}</td>
      </tr>
    }
  }
</table>

<h3>Beskeder</h3>
@if (log.isLoading()) {
  <p-skeleton width="10rem" class="mb-2" />
  <p-skeleton width="5rem" class="mb-2" />
  <p-skeleton width="15rem" class="mb-2" />
}

@let logEntries = log.value();
@if (logEntries) {
  <p-table
    [value]="logEntries"
    [loading]="log.isLoading()"
    [showGridlines]="true"
    stripedRows
    class="p-datatable-sm lp-table">
    <ng-template pTemplate="header">
      <tr>
        <th>Tidspunkt</th>
        <th>Type</th>
        <th>Besked</th>
      </tr>
    </ng-template>
    <ng-template [appTableRow]="logEntries" pTemplate="body" let-item>
      <tr [pSelectableRow]="item" class="cursor-pointer">
        <td class="numbers">
          {{ item.tidspunkt | date: 'dd-MM-yyyy HH:mm:ss' }}
        </td>
        <td>
          {{ item.alvorlighedsgrad }}
        </td>
        <td>
          <pre>{{ item.besked }}</pre>
        </td>
      </tr>
    </ng-template>
  </p-table>
}
<p-confirm-dialog />
